export const getImageUrl = (imageName) => {
  if (!imageName) return "";

  const baseUrl = process.env.BACKEND_URL?.replace("/api", "");
  return `${baseUrl}/public/images/${imageName}`;
};
